module.exports = __webpack_public_path__ + "img/logo-sidebar.645c30c8.png";